import React from "react";
import styled, { css } from "styled-components";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery";
import typographySizes from "styles/typographySizes.js";
import colors from "styles/colors.js";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { Link } from "gatsby";

const sharedStyles = css`
 background-color: ${colors.dark};
  color: ${colors.main};
  font-size: ${typographySizes.text.tekstSize6.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize6.lineHeight};
  display: inline-block;
  align-self: flex-start;
  padding: 1rem;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: ${colors.secondary};

  }
  @media (max-width: ${mediaQuery.laptop}) {
    font-size: ${typographySizes.text.tekstSize3.size.mobile}rem;
  }
`;

const StyledLink = styled.a`
  ${sharedStyles}
`;

const StyledGatsbyLink = styled(Link)`
  ${sharedStyles}
`;

const StyledScrollLink = styled(ScrollLink)`
  ${sharedStyles}
`;

const BoxBtn = ({ scroll, pageLink, to, children, href, ...props }) => {
  if (scroll) {
    return (
      <StyledScrollLink to={to} smooth={true} duration={500} {...props}>
        [{children}]
      </StyledScrollLink>
    );
  }

  if (pageLink) {
    return (
      <StyledGatsbyLink to={to} {...props}>
        [{children}]
      </StyledGatsbyLink>
    );
  }

  return (
    <StyledLink href={href} {...props}>
      [{children}]
    </StyledLink>
  );
};

export default BoxBtn;
